import { SagaIterator } from 'redux-saga';
import { put, call, fork, takeLatest, cancel } from 'redux-saga/effects';
import { Folder } from '../types';
import { clearNotifications } from '../../../../common/navigation/state/actions/index';
import { fetchCount } from './realtime-count';
import { startCommentsRealtimeCounter, cancelCommentsRealtimeCounter } from './index';

const POLLING_DELAY = 60 * 1000;

const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export function* cancelPolling(pollTask) {
  yield cancel(pollTask);
  yield put(clearNotifications({ notificationType: 'comments' }));
}

// Worker sagas
export function* pollRealtimeCount(): SagaIterator {
  while (true) {
    yield call(delay, POLLING_DELAY);
    yield fork(fetchCount, { polling: true, folder: Folder.PENDING, contentType: 'COMMENTS' });
  }
}

// This method initializes the polling loop that does two things:
// 1. Creates a forked task from the poll API call
// 2. Passes in the forked task as an argument to a watching function that will cancel a task
export function* pollOrCancelRealtimeCount(action) {
  const pollTask = yield fork(pollRealtimeCount);
  yield watchCancelRealtimeCount(pollTask);
}

// Watcher sagas
export function* watchCancelRealtimeCount(pollTask) {
  yield takeLatest(cancelCommentsRealtimeCounter.type, () => cancelPolling(pollTask));
}

export function* watchRealtimeCount() {
  yield takeLatest(startCommentsRealtimeCounter.type, pollOrCancelRealtimeCount);
}

// Main saga
export default function* realtimeCountSaga() {
  yield watchRealtimeCount();
}
